import config from "@/config"
import http from "@/utils/request"
// import tool from "@/utils/tool"
export default {
  applyment: {
    url: `${config.API_URL}`,
    // url: `${config.API_URL}/permission/store`,
    name: "微信提交申请单",
    submit: async function (params) {
      return await http.post(`${this.url}/merchantApply/wx/applyment/submit`, params)
    },
    get: async function (params) {
      return await http.get(`${this.url}/merchantApply/user/applyment/getInfo`, params)
    }
  }
}
